if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
    navigator.enumerateDevices = function(callback) {
        navigator.mediaDevices.enumerateDevices().then(callback);
    };
}

let MediaDevices = [];
const isHTTPs = window.location.protocol === 'https:' || window.location.pathname.includes('localhost') || window.location.pathname.includes('127.0.0.1');
let canEnumerate = false;

if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
    canEnumerate = true;
} else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
    canEnumerate = true;
}

const DevicePermission = async () => {
    return new Promise((resolve, reject) => {
        const response = {
            hasMicrophone: false,
            hasSpeakers: false,
            hasWebcam: false,
            isMicrophoneAlreadyCaptured: false,
            isWebcamAlreadyCaptured: false
        };

        if (!canEnumerate) {
            resolve(response);
        }

        if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
            navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
        }

        if (!navigator.enumerateDevices && navigator.enumerateDevices) {
            navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
        }

        if (!navigator.enumerateDevices) {
            return false;
        }

        MediaDevices = [];

        try {
            navigator.enumerateDevices(function(devices) {
                devices.forEach(function(_device) {
                    const device = {};

                    for (const d in _device) {
                        device[d] = _device[d];
                    }

                    if (device.kind === 'audio') {
                        device.kind = 'audioinput';
                    }

                    if (device.kind === 'video') {
                        device.kind = 'videoinput';
                    }

                    let skip;

                    MediaDevices.forEach(function(d) {
                        if (d.id === device.id && d.kind === device.kind) {
                            skip = true;
                        }
                    });

                    if (skip) {
                        return;
                    }

                    if (!device.deviceId) {
                        device.deviceId = device.id;
                    }

                    if (!device.id) {
                        device.id = device.deviceId;
                    }

                    if (!device.label) {
                        device.label = 'Please invoke getUserMedia once.';

                        if (!isHTTPs) {
                            device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
                        }
                    } else {
                        if (device.kind === 'videoinput' && !response.isWebcamAlreadyCaptured) {
                            response.isWebcamAlreadyCaptured = true;
                        }

                        if (device.kind === 'audioinput' && !response.isMicrophoneAlreadyCaptured) {
                            response.isMicrophoneAlreadyCaptured = true;
                        }
                    }

                    if (device.kind === 'audioinput') {
                        response.hasMicrophone = true;
                    }

                    if (device.kind === 'audiooutput') {
                        response.hasSpeakers = true;
                    }

                    if (device.kind === 'videoinput') {
                        response.hasWebcam = true;
                    }

                    MediaDevices.push(device);
                });

                resolve(response);
            });
        } catch (error) {
            reject(error);
        }
    });
};

export default DevicePermission;
